<select
  class="form-control"
  [id]="uuid() + group().id"
  [attr.data-testing-id]="group().id"
  (change)="optionChange(group().id, $event.target)"
>
  @for (option of group().options; track option; let i = $index) { @if (!hasActiveElement() && i === 0) {
  <option></option>
  } @if (!option.alternativeCombination || multipleOptions()) {
  <option [value]="option.value" [selected]="option.active" [attr.data-testing-id]="group().id + '-' + option.value">
    {{ option.label }}
    @if (option.alternativeCombination) { - {{ 'product.available_in_different_configuration' | translate }}
    }
  </option>
  } }
</select>
